import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  PriceTypeFirestoreResponse,
  CreatePriceTypeDto,
  UpdatePriceTypeDto,
  DeletePriceTypeResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const PriceTypeResponseSchema = PriceTypeFirestoreResponse;
export const CreatePriceTypeSchema = CreatePriceTypeDto;
export const UpdatePriceTypeSchema = UpdatePriceTypeDto;
export const DeleteResponseSchema = DeletePriceTypeResponseDto;

// Type exports
export type PriceTypeResponse = z.infer<typeof PriceTypeFirestoreResponse>;
export type CreatePriceType = z.infer<typeof CreatePriceTypeDto>;
export type UpdatePriceType = z.infer<typeof UpdatePriceTypeDto>;

// API factory function
export function createPriceTypesApi(client: TypedApiClient) {
  return {
    getPriceTypes: (): Promise<PriceTypeResponse[]> => {
      return client.get('/price-types', {
        responseSchema: z.array(PriceTypeResponseSchema),
      });
    },

    createPriceType: (data: CreatePriceType): Promise<PriceTypeResponse> => {
      CreatePriceTypeSchema.parse(data);
      return client.post('/price-types', {
        data,
        responseSchema: PriceTypeResponseSchema,
      });
    },

    updatePriceType: (id: string, data: UpdatePriceType): Promise<PriceTypeResponse> => {
      return client.patch(apiPath`/price-types/${id}`, {
        data,
        responseSchema: PriceTypeResponseSchema,
      });
    },

    deletePriceType: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/price-types/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
